import React, { useState } from 'react';
import '../../styles/Dashboard.css'
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";

export default function BotPresence({ dark, setDark, sidebarOpen, setSidebarOpen }) {
    const toggleTheme = () => setDark(!dark);

    const [name, setName] = useState('');
    const [type, setType] = useState('Playing');
    const [status, setStatus] = useState('online');
    const [saved, setSaved] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleSave = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setError(null);
        setSaving(true);
        const payload = { name, type, status };

        try {
            // POST directly to public API as requested
            const res = await fetch('https://api.industriegaming.fr/api/bot/presence', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const text = await res.text();
            let body = null;
            try { body = JSON.parse(text); } catch (e) { body = text; }

            if (!res.ok) {
                console.error('Presence save failed', res.status, body);
                setError((body && body.message) ? body.message : `Upstream returned ${res.status}`);
                setSaved(false);
            } else {
                console.log('Presence saved OK', body);
                setSaved(true);
                setTimeout(() => setSaved(false), 2500);
            }
        } catch (err) {
            console.error('Network error saving presence', err);
            setError(String(err));
            setSaved(false);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                <div className="content">
                    <div className="users-header">
                        <div className="users-header-logo">
                            <h1>Présence</h1>
                            <p style={{ marginTop: 6, opacity: 0.8 }}>Définir la présence affichée par le bot Discord.</p>
                        </div>

                        <div className="users-header-logo">
                            <div className="results-count">
                                {saved ? 'Dernière présence sauvegardée' : 'Prête à sauvegarder'}
                            </div>
                            <button className="add-user-btn" onClick={handleSave}>Sauvegarder</button>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <span className="card-title">Paramètres de la présence</span>
                        </div>

                        <form style={{ display: 'flex', flexDirection: 'column', gap: 12 }} onSubmit={handleSave}>
                            <label>
                                Nom de la présence
                                <input className="form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex: PZ Admin" />
                            </label>

                            <label>
                                Type de présence
                                <select className="form-input" value={type} onChange={(e) => setType(e.target.value)}>
                                    <option>Playing</option>
                                    <option>Streaming</option>
                                    <option>Listening</option>
                                    <option>Watching</option>
                                    <option>Competing</option>
                                </select>
                            </label>

                            <label>
                                Status
                                <select className="form-input" value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value="online">Online</option>
                                    <option value="idle">Idle</option>
                                    <option value="dnd">Do Not Disturb</option>
                                    <option value="invisible">Invisible</option>
                                </select>
                            </label>

                            <div style={{ display: 'flex', gap: 8 }}>
                                <button className="action-btn" type="submit">Sauvegarder</button>
                                {saved ? <div style={{ alignSelf: 'center', color: '#10b981' }}>Sauvegardé</div> : null}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
